import { createSelector } from 'reselect'
import { floatify } from 'lib/maths/mathUtils'
import getGroupPaymentPreviewRequestInfo from './getGroupPaymentPreviewRequestInfo'
import {
  getSavedGroupPaymentFingerprint,
  getSavedGroupPaymentPreview,
} from './getGroupPaymentLeadContributionAmount'

/**
 * What the lead pays today before fees and credits: their share plus lead-only items.
 * Comes from the saved preview's deposit charge, the same way getPaymentScheduleDepositAmount works.
 * 0 when there is no preview for the current cart.
 */
const getGroupPaymentDepositAmount = createSelector(
  getSavedGroupPaymentPreview,
  getSavedGroupPaymentFingerprint,
  getGroupPaymentPreviewRequestInfo,
  (preview, savedFingerprint, requestInfo): number => {
    if (!preview?.eligible || !requestInfo || savedFingerprint !== requestInfo.fingerprint) {
      return 0
    }
    const depositAmount = preview.charges?.find(charge => charge.paymentType === 'deposit')?.expectedAmount || 0
    return floatify(depositAmount)
  },
)

/**
 * The part of the deposit that credits and gift cards can pay: the deposit less lead-only items,
 * which svc-payment doesn't let credits or gift cards pay for.
 */
export const getGroupPaymentCreditPayableAmount = createSelector(
  getGroupPaymentDepositAmount,
  getGroupPaymentPreviewRequestInfo,
  (depositAmount, requestInfo): number => (
    depositAmount > 0 ? Math.max(0, floatify(depositAmount - (requestInfo?.leadOnlyTotal ?? 0))) : 0
  ),
)

export default getGroupPaymentDepositAmount
